import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { LoadingOverlayProvider } from "./components/LoadingOverlayProvider";

const container = document.getElementById("root");
if (!container) throw new Error("Root container missing in index.html");

const root = ReactDOM.createRoot(container as HTMLElement);
root.render(
  <React.StrictMode>
    <LoadingOverlayProvider>
      <App />
    </LoadingOverlayProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
